diy.angular.registerFactory('diyfmblocking', [function() {
    var blockingStack = [];
    return {
        block: function(reasonMessage) {
            var reason = {};
            reason.message = reasonMessage;
            blockingStack.push(reason);
            
            return function unblock() {
                blockingStack.splice(blockingStack.indexOf(reason), 1);
            };
        },
        isBlocked: function() {
            return blockingStack.length > 0;
        },
        getReasons: function() {
            var ret = [];
            return blockingStack.map(function(reason){
                return reason.message;
            });
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmblocking.js
 ** module id = 944
 ** module chunks = 0
 **/